module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Available"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Expires"}}